module.exports = __webpack_public_path__ + "public/images/overview/Golubeva.fe6128d68a1a447cb8485bbf5ead76b6.jpg";